import React, { Component, PropTypes } from 'react';
import { Units, Colors } from 'Css';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    margin: Units.base / 4,
    borderRadius: 2,
    borderStyle: 'solid',
    borderWidth: '1px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
    alignContent: 'stretch',
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'flex-start',
    borderColor: Colors.material.grey[300].hex,
    backgroundColor: Colors.theme.Light.card,
    '&transparent': {
      backgroundColor: 'transparent',
      border: 'none'
    },
    dense: {
      margin: 0
    },
    '&right': {
      marginLeft: 'auto'
    },
    '&fullWidth': {
      flexGrow: 1,
      flexShrink: 0
    }
  }
});

class ToolbarGroup extends Component {
  static propTypes = {
    children: PropTypes.node,
    right: PropTypes.bool,
    transparent: PropTypes.bool,
    fullWidth: PropTypes.bool,
    dense: PropTypes.bool
  };

  render() {
    const {
      children,
      right,
      fullWidth,
      transparent,
      dense,
      ...other
    } = this.props;
    const classes = classNames(css.root, {
      [css.right]: right,
      [css.dense]: dense,
      [css.transparent]: transparent,
      [css.fullWidth]: fullWidth
    });
    return (
      <div className={classes} {...other}>
        {children}
      </div>
    );
  }
}

export default ToolbarGroup;



// WEBPACK FOOTER //
// ./src/js/Cio/Toolbar/ToolbarGroup.js